export const isImpersonationCallbackLocation = (pathname: string, search: string) => {
  if (pathname === '/auth/callback') return true;
  if (pathname !== '/') return false;

  const params = new URLSearchParams(search);
  return params.has('access_token') || params.has('refresh_token');
};
